import { useEffect, useState } from "react";
import { EventSourcePolyfill } from "event-source-polyfill";
import { getToken } from "../../apis/authentication";

const useEvent = (url) => {
  const [data, setData] = useState(0);
  const [error, setError] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    let result = startConnection();

    return result
    // // Cleanup on component unmount
    // return () => {
    //   if (eventSource) {
    //     eventSource.close();
    //   }
    // };
  }, [url]);

  let eventSource = null;

  function startConnection() {
    const token = getToken();
    eventSource = new EventSourcePolyfill(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      heartbeatTimeout:5000000
    });

    eventSource.onopen = () => {
      console.log("Connection established");
      setConnected(true);
    };

    eventSource.onmessage = (event) => {
      console.log("Data received:", event.data);
      setData((prev) => prev + 1); // Update state with received data
    };

    eventSource.onerror = (err) => {
      console.error("SSE error:", err);
      setError("Connection error");
      if (!connected) {
        // Retry connection if it's not yet established
        startConnection();
      }
      eventSource.close(); // Close connection on error
    };
  }

  return { data, error };
};

export default useEvent;
